module.exports = __webpack_public_path__ + "static/media/hdc-51-wifi.05c9a4c7.png";